function Filter() {
  this.ajax = new Ajax();
}
Filter.prototype.initAll = function () {
  this.initPagination();
  // this.initSortBy();
  this.initView();
  this.initProductTag();
}
Filter.prototype.initPagination = function () {
  var self = this;

  // $(".collection-pagination .pagination span a").unbind('click').bind("click",function(e){ // When btn is pressed.
  $(".collection-pagination .pagination span a").on('click', function (e) {
    // $(document).on('click', '.collection-pagination .pagination span a', function(e) {
    var href = $(this).attr("href");
    var page = href.match(/page=\d+/g);
    if (page) {
      Shopify.queryParams.page = parseInt(page[0].match(/\d+/g));
      if (Shopify.queryParams.page) {
        var newurl = self.ajax.filterCreateUrl();
        history.pushState({
          param: Shopify.queryParams
        }, newurl, newurl);
        self.ajax.loadData(newurl, self.renderProductList.bind(self));
      }
      var scrollTop = $('#CollectionAjaxResult').offset().top - $('.header-wrapper').height();
      $("body,html").animate({
        scrollTop: scrollTop
      }, 600);
    }
    e.preventDefault();
    $('body').addClass('ajax-loading');
  });
}
Filter.prototype.initSortBy = function () {
  var self = this;
  $(".collection-content #SortBy, .collection-filter #SortBy").change(function (e) {
    e.preventDefault();
    var sortType = $(this).val();
    Shopify.queryParams.sort_by = sortType;
    self.ajax.filterAjaxClick(null, self.renderProductList.bind(self));
    $('body').addClass('ajax-loading');
  });
  $(document).on('change', '#filter-sory-by-t', function (e) {
    var sortType = $('input[name=filter-sory-by]:checked', '#filter-sory-by').val();
    Shopify.queryParams.sort_by = sortType;
    self.ajax.filterAjaxClick(null, self.renderProductList.bind(self));
    e.preventDefault();
    $('body').addClass('ajax-loading');
  });
  // $("#filter-sory-by").change(function (e) {
  //     var sortType = $('input[name=filter-sory-by]:checked', '#filter-sory-by').val();
  //     Shopify.queryParams.sort_by = sortType;
  //     self.ajax.filterAjaxClick(null, self.renderProductList.bind(self));
  //     e.preventDefault();
  //     $('body').addClass('ajax-loading');
  // });
}
Filter.prototype.initView = function () {
  var self = this;
  $(".collection-view button").click(function (e) {
    if (!$(this).hasClass(".change-view--active")) {
      var paging = $(".pagination .page.current").html();
      Shopify.queryParams.view = $(this).attr('data-view');
      self.ajax.filterAjaxClick(null, self.renderProductList.bind(self));
    }
    e.preventDefault();
    $('body').addClass('ajax-loading');
  });
}
Filter.prototype.initProductTag = function () {
  var self = this;
  var redirect = false;

  $(".filter-block .filter-content input[type='checkbox']").click(function (e) {
    if($(window).width() < 768) {
      return
    }
    var currentTags = [];
    if (Shopify.queryParams.constraint) {
      currentTags = Shopify.queryParams.constraint.split('+');
    }
    var parent = $(this).parents('.filter-block');
    var valueOldTag = parent.find('input[checked]').val();
    var value = $(this).parent().find('input').val();
    var tagPosition = currentTags.indexOf(value);
    if (tagPosition >= 0) {
      currentTags.splice(tagPosition, 1);
    } else {
      if (value !== 'all')
        currentTags.push(value);
    }
    var oldTagPosition = currentTags.indexOf(valueOldTag);
    if (oldTagPosition >= 0) {
      // Uncomment the following line to disable multi select functionality on the filter sidebar
      currentTags.splice(oldTagPosition, 1);
    }
    if (currentTags.length) {
      Shopify.queryParams.constraint = currentTags.join('+');
    } else {
      delete Shopify.queryParams.constraint;
    }
    self.ajax.filterAjaxClick(null, self.renderProductList.bind(self));

    var scrollTop = $('#CollectionAjaxResult').offset().top - $('.header-wrapper').height();
    $("body,html").animate({
      scrollTop: scrollTop
    }, 600);

    e.preventDefault();
    $('body').addClass('ajax-loading');
  });

  $(".filter-block .filter-content input[type='radio']").click(function (e) {
    if($(window).width() < 768) {
      return
    }
    var currentTags = [];
    if (Shopify.queryParams.constraint) {
      currentTags = Shopify.queryParams.constraint.split('+');
    }
    var parent = $(this).parents('.filter-block');
    var newTag = $("input[type='radio']:checked", parent).val();

    var innerInputs = parent.find("input[type='radio']");
    for (var i = 0; i < innerInputs.length ; i ++) {
      var itemVal = $(innerInputs[i]).val();
      var itemPosition = currentTags.indexOf(itemVal);
      if (itemPosition >= 0) {
        currentTags.splice(itemPosition, 1);
      }
    }

    if (newTag.length > 0) {
      currentTags.push(newTag);
    }

    if (currentTags.length) {
      Shopify.queryParams.constraint = currentTags.join('+');
    } else {
      delete Shopify.queryParams.constraint;
    }
    self.ajax.filterAjaxClick(null, self.renderProductList.bind(self));

    var scrollTop = $('#CollectionAjaxResult').offset().top - $('.header-wrapper').height();
    $("body,html").animate({
      scrollTop: scrollTop
    }, 600);

    e.preventDefault();
    $('body').addClass('ajax-loading');
  });

  $(document).on('click', '.jw-filter-tags .filter-block ul li .js-remove-tag', function (e) {
    var currentTags = [];
    if (Shopify.queryParams.constraint) {
      currentTags = Shopify.queryParams.constraint.split('+');
    }
    var value = $(this).parent('li').data('tag');
    var tagPosition = currentTags.indexOf(value);

    currentTags.splice(tagPosition, 1);

    if (currentTags.length) {
      Shopify.queryParams.constraint = currentTags.join('+');
    } else {
      delete Shopify.queryParams.constraint;
    }
    self.ajax.filterAjaxClick(null, self.renderProductList.bind(self));

    $("body,html").animate({
      scrollTop: 0
    }, 600);

    e.preventDefault();
    $('body').addClass('ajax-loading');
  });

  $(".filter-block .filter-clear .clear-all").click(function (e) {

    delete Shopify.queryParams.constraint;
    delete Shopify.queryParams.sort_by;

    self.ajax.filterAjaxClick(null, self.renderProductList.bind(self));

    var scrollTop = $('#CollectionAjaxResult').offset().top - $('.header-wrapper').height();
    $("body,html").animate({
      scrollTop: scrollTop
    }, 600);

    e.preventDefault();
    $('body').addClass('ajax-loading');

    updateFilterCounts();
    applyFilter();
  });

  $("#FilterContainer .filter-nav-clear").click(function (e) {
    if ($('#FilterDrawer').length > 0) {
      $('input[name="filter-sort-by"]').prop('checked', false);
      $('input[name="filter-category"]').prop('checked', false);
      $('input[name="filter-gauge-size"]').prop('checked', false);
      $('input[name="filter-color"]').prop('checked', false);
      $('input[name="filter-gemstone"]').prop('checked', false);
    }

    updateFilterCounts();
    applyFilter();
  });

  $("#SortModal input[name=filter-sort-by]").unbind('change').bind('change', function (e) {
    e.preventDefault();
    applyFilter();
  });

  $("#FilterContainer .filter-nav-apply").click(function (e) {
    e.preventDefault();
    applyFilter();
  });

  $("#CollectionFilter input[name=filter-side-category]").unbind('click').bind('click', function (e) {
    applyFilterV2();
  });

  $("#CollectionFilter input[name=filter-side-gauge-size]").unbind('click').bind('click', function (e) {
    applyFilterV2();
  });

  $("#CollectionFilter input[name=filter-side-color]").unbind('click').bind('click', function (e) {
    applyFilterV2();
  });

  $("#CollectionFilter input[name=filter-side-gemstone]").unbind('click').bind('click', function (e) {
    applyFilterV2();
  });

  $(".collection-filter-v2 #SortBy").unbind('change').bind('change', function (e) {
    applyFilterV2();
  });

  $("#CollectionFilter .filter-side-clear").unbind('click').bind('click', function (e) {
    if ($('#CollectionFilter').length > 0) {
      // $('input[name="filter-side-category"]').prop('checked', false);
      $('input[name="filter-side-gauge-size"]').prop('checked', false);
      $('input[name="filter-side-color"]').prop('checked', false);
      $('input[name="filter-side-gemstone"]').prop('checked', false);
    }

    applyFilterV2();
  });

  $("#FilterContainer input[type='radio']").click(function (e) {
    redirect = false;
    if ($(e.target).attr('name') === 'filter-category') {
      redirect = true;
    }
    updateFilterCounts();
    applyFilter();
  });

  $("#FilterContainer input[type='checkbox']").click(function (e) {
    updateFilterCounts();
    applyFilter();
  });

  if ($("#FilterContainer").length > 0) {
    updateFilterCounts();
  }

  function updateFilterCounts() {
    var searchQuery = generateSearchQuery();
    var query = searchQuery.query;
    var nFilterCounts = 0;

    if (query) {
      nFilterCounts = (query.match(/\+/g) || []).length + 1;
      nFilterCounts += (query.match(/\?/g) || []).length;
      // nFilterCounts += (query.match(/sort_by/g) || []).length;
    }

    if (nFilterCounts > 0) {
      nFilterCounts = ' (' + nFilterCounts + ')';
      $('#FilterContainer .filter-counts').html(nFilterCounts);
    } else {
      $('#FilterContainer .filter-counts').html('');
    }
  }

  function generateSearchQuery() {
    // Init search query
    var searchQuery = '';
    var needRedirect = redirect;

    // Check filter values
    if ($('#FilterDrawer').length > 0) {
      // Search Category
      var valueTagCategory = $('input[name=filter-category]:checked', '.filter-category').val();

      // Search Query
      var valueTagGaugeSize = $('input[name=filter-gauge-size]:checked', '#filter-gauge-size').val();
      var valueTagColor = $('input[name=filter-color]:checked', '#filter-color').val();
      var valueTagGemstone = $('input[name=filter-gemstone]:checked', '#filter-gemstone').val();

      if (valueTagGaugeSize && valueTagGaugeSize !== 'all-gauge')
        searchQuery += valueTagGaugeSize + "+";

      if (valueTagColor)
        searchQuery += valueTagColor + "+";

      if (valueTagGemstone && valueTagGemstone !== 'all-gemstone')
        searchQuery += valueTagGemstone + "+";

      // Combine Search Query
      if (needRedirect) {
        searchQuery = searchQuery !== "" ? "/collections/" + valueTagCategory + "?constraint=" + searchQuery : "/collections/" + valueTagCategory;
      }
    }

    if (searchQuery.length > 0 && searchQuery[searchQuery.length - 1] === "+") {
      var lastChar = searchQuery[searchQuery.length - 1];
      if (lastChar === "+")
          searchQuery = searchQuery.substring(0, searchQuery.length - 1);
    }

    if ($("#SortModal").length > 0) {
      var valueSortType = $('input[name=filter-sort-by]:checked', '#SortModal').val();
      if (needRedirect && valueSortType) {
        var prefix = searchQuery.includes('constraint=') ? '&' : '?';
        searchQuery += prefix + "sort_by=" + valueSortType;
      }
    }

    return {
      needRedirect: needRedirect,
      query: searchQuery
    }
  }

  function applyFilter() {
    // get search query
    var searchQuery = generateSearchQuery();
    var query = "";

    if (searchQuery.needRedirect) {
      window.location.href = searchQuery.query;
      return;
    } else {
      query = searchQuery.query;
    }

    if (query.length > 0) {
      Shopify.queryParams.constraint = query;
    } else {
      delete Shopify.queryParams.constraint;
    }

    // Check Sort Type
    var sortType = $('input[name=filter-sort-by]:checked', '#SortModal').val();
    if (sortType) {
      Shopify.queryParams.sort_by = sortType;
    } else {
      delete Shopify.queryParams.sort_by;
    }

    self.ajax.filterAjaxClick(null, self.renderProductList.bind(self));

    var scrollTop = $('#MainContent').offset().top - $('.header-wrapper').height();
    $("body,html").animate({
      scrollTop: scrollTop
    }, 600);

    $('body').addClass('ajax-loading');
  }

  function applyFilterV2() {
    // get search query
    var searchQuery = self.generateSearchQueryV2();
    var query = "";

    if (searchQuery.needRedirect) {
      window.location.href = searchQuery.query;
      return;
    } else {
      query = searchQuery.query;
    }

    if (query.length > 0) {
      Shopify.queryParams.constraint = query;
    } else {
      delete Shopify.queryParams.constraint;
    }

    // Check Sort Type
    var sortType = $('.collection-filter-v2 #SortBy').val();
    if (sortType) {
      Shopify.queryParams.sort_by = sortType;
    } else {
      delete Shopify.queryParams.sort_by;
    }

    self.ajax.filterAjaxClick(null, self.renderProductList.bind(self));

    var scrollTop = $('#MainContent').offset().top - $('.header-wrapper').height();
    $("body,html").animate({
      scrollTop: scrollTop
    }, 600);

    $('body').addClass('ajax-loading');
  }

  if ($("#CollectionFilter").length > 0) {
    this.updateFilterCountsV2();
  }
}
Filter.prototype.generateSearchQueryV2 = function() {
  // Init search query
  var searchQuery = '';
  var needRedirect = false;

  // Check filter values
  if ($('#CollectionFilter').length > 0) {
    // Search Category
    var valueTagCategory = $('input[name=filter-side-category]:checked', '.filter-side-category').val();
    var activeCategory = $('#filter-side-category').data('collection');
    if (!valueTagCategory || valueTagCategory === activeCategory) {
      valueTagCategory = '';
    } else {
      needRedirect = true;
    }

    // Search Query
    var valueTagGaugeSize = $('input[name=filter-side-gauge-size]:checked', '#filter-side-gauge-size').val();
    var valueTagColor = $('input[name=filter-side-color]:checked', '#filter-side-color').val();
    var valueTagGemstone = $('input[name=filter-side-gemstone]:checked', '#filter-side-gemstone').val();

    if (valueTagGaugeSize && valueTagGaugeSize !== 'all-gauge')
      searchQuery += valueTagGaugeSize + "+";

    if (valueTagColor)
      searchQuery += valueTagColor + "+";

    if (valueTagGemstone && valueTagGemstone !== 'all-gemstone')
      searchQuery += valueTagGemstone + "+";

    // Combine Search Query
    if (needRedirect) {
      searchQuery = searchQuery !== "" ? "/collections/" + valueTagCategory + "?constraint=" + searchQuery : "/collections/" + valueTagCategory;
    }
  }

  if (searchQuery.length > 0 && searchQuery[searchQuery.length - 1] === "+") {
    var lastChar = searchQuery[searchQuery.length - 1];
    if (lastChar === "+")
      searchQuery = searchQuery.substring(0, searchQuery.length - 1);
  }

  if ($(".collection-filter-v2 #SortBy").length > 0) {
    var valueSortType = $('.collection-filter-v2 #SortBy').val();
    if (needRedirect && valueSortType) {
      var prefix = searchQuery.includes('constraint=') ? '&' : '?';
      searchQuery += prefix + "sort_by=" + valueSortType;
    }
  }

  return {
    needRedirect: needRedirect,
    query: searchQuery
  }
}

Filter.prototype.updateFilterCountsV2 = function() {
  var searchQuery = this.generateSearchQueryV2();
  var query = searchQuery.query;
  var nFilterCounts = 0;

  if (query) {
    nFilterCounts = (query.match(/\+/g) || []).length + 1;
    nFilterCounts += (query.match(/\?/g) || []).length;
    // nFilterCounts += (query.match(/sort_by/g) || []).length;
  }

  if (nFilterCounts > 0) {
    $('#CollectionFilter .filter-counts').html(nFilterCounts).removeClass('hide');
  } else {
    $('#CollectionFilter .filter-counts').html('').addClass('hide');
  }
}
Filter.prototype.initViewMoreTagsBlock = function () {
  $('.block-tags .nt-sidebar-content ul').attr('style', 'height: 210px; overflow: hidden;')
  $('.block-tags .nt-sidebar-content').append('<a href="#" class="more-tags">' + 'Translation missing: en.collections.general.view_more' + '</a>')
  $('a.more-tags').click(function (e) {
    e.preventDefault();
    if ($(this).text() == 'Translation missing: en.collections.general.view_more') {
      $('.block-tags .nt-sidebar-content ul').removeAttr('style')
      $(this).text('Less')
      return;
    } else if ($(this).text() == 'Less') {
      $('.block-tags .nt-sidebar-content ul').attr('style', 'height: 210px; overflow: hidden;')
      $(this).text('Translation missing: en.collections.general.view_more')
    }
  })
}
Filter.prototype.initLoadMore = function (className) {
  window.ias = jQuery.ias({
    container: '.' + className,
    item: '.grid__item',
    pagination: '.' + className + ' .pagination',
    next: '.next a'
  });
  
  window.ias.extension(new IASSpinnerExtension({}));
  var itemLength = 0;
  window.ias.on('render', function () {
    itemLength = $(".nt-des-top").length;
  })
  window.ias.on('rendered', function (items) {
    var imageShopify = new ImageShopify();
    imageShopify.initImageConfigure(items);
    var countDownShopify = new CountDownShopify();
    countDownShopify.initAll(items);
    var cart = new Cart();
    cart.initAddToCart(items);
    var currentClassName = $(".nt-collection-content > div")[1].className;
    setTimeout(function () {
      if(currentClassName === 'nt-product-grid'){
        imageShopify.initSetProductHeightLoadMore(itemLength - 1);
      }else{
        imageShopify.initSetProductHeight();
      }
    }, 420);
  })
}
Filter.prototype.renderProductList = function (data, callback) {
  // Update Collection Section
  var currentCollectionSection = $("#CollectionAjaxContent");
  var newCollectionSection = $(data).find("#CollectionAjaxContent");
  currentCollectionSection.replaceWith(newCollectionSection);

  // Update Collection Layout
  var layoutType = theme.base.collectionLayoutType;
  if (layoutType === 'layout-single')
    $("#CollectionSection").removeClass('grid-column').addClass('grid-single');
  else
    $("#CollectionSection").removeClass('grid-single').addClass('grid-column');

  // Update Mobile Filter
  // var currentMobileFilter = $("#FilterContainer");
  // var newMobileFilter = $(data).find("#FilterContainer");
  // currentMobileFilter.replaceWith(newMobileFilter);
  // this.initProductTag();

  // Pagination
  var currentPagingToolbar = $(".collection-pagination .pagination");
  var newPagingToolbar = $(data).find(".collection-pagination .pagination");
  if (currentPagingToolbar.length > 0) {
    if (newPagingToolbar.length > 0) {
      currentPagingToolbar.replaceWith(newPagingToolbar);
    } else {
      currentPagingToolbar.remove();
    }
  } else {
    if (newPagingToolbar.length > 0) {
      $(".collection-pagination").append(newPagingToolbar);
    }
  }
  this.initPagination();

  // Filter Tags
  var currentFilterTags = $(".collection-filter-v2 .jw-filter-tags");
  var newFilterTags = $(data).find(".collection-filter-v2 .jw-filter-tags");
  currentFilterTags.replaceWith(newFilterTags);

  // Sory by (mobile)
  var currentSortByToolbar = $(".collection-content #SortBy");
  var newPageSortByToolbar = $(data).find(".collection-content #SortBy");
  currentSortByToolbar.replaceWith(newPageSortByToolbar);

  // Sory by (desktop)
  // currentSortByToolbar = $(".collection-filter-v2 #SortBy");
  // newPageSortByToolbar = $(data).find(".collection-filter-v2 #SortBy");
  // currentSortByToolbar.replaceWith(newPageSortByToolbar);

  var mobileSortBy = $("#filter-sory-by");
  var newMobileSortBy = $(data).find("#filter-sory-by");
  mobileSortBy.replaceWith(newMobileSortBy);
  this.initSortBy();

  // Remove Ajax Loading Session
  $('body').removeClass('ajax-loading');

  this.updateFilterCountsV2();

  // Create a new ajax load more instance
  // var endlessScroll = new Ajaxinate({
  //   container: '#AjaxinateLoop',
  //   pagination: '#AjaxinatePagination',
  //   loadingText: '<img src="https://cdn.shopify.com/s/files/1/0066/2106/9369/t/3/assets/ajax-loader.gif?8857046633127187117" style="width: 30px" alt="Loading...">'
  // });

  // Re assign swatch actions
  if( $('.jw-product-item-swatch').length > 0 ) {
    Array.prototype.forEach.call($('.jw-product-item-swatch'), function (item) {
      new theme.Swatch($(item));
    });
  }

  // Refresh currency after filtered items(sorted out the items)
  theme?.currencySwitcher?.ajaxrefresh();
}
